export default __webpack_public_path__ + "static/media/quiz_bg.be8a0153.png";